
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/school/certified-teachers",
      function () {
        return require("private-next-pages/school/certified-teachers.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/school/certified-teachers"])
      });
    }
  